<template>
  <div class="deals">
    <div class="active-disputes">
      <div class="active-disputes__title">
        <span class="text-capitalize-first">{{ $t('labels.active_disputes')}}</span>
      </div>
      <DealsSection :hide-header="true" ref="activeDisputesSection"></DealsSection>
    </div>
    <div class="all-disputes">
      <div class="all-disputes__title">
        <span class="text-capitalize-first">{{ $t('labels.last_disputes')}}</span>
      </div>
      <DealsSection :hide-header="true" ref="lastDisputesSection"></DealsSection>
    </div>
  </div>
</template>
<script lang="ts">
import {computed, defineComponent, onMounted, onUnmounted, reactive, ref, toRefs} from 'vue'
import {$t, helper} from "@/service/CommonHelper";
import {useRoute} from "vue-router";
import TraderDashboard from "@/apps/public/components/dashboard/TraderDashboard.vue";
import {useStore} from "vuex";
import {Direction} from "@/models/enum/Direction";
import DealRequestDTO, { defaultRequestDTO } from "@/models/request/DealRequestDTO";
import {DealStatus} from "@/models/enum/DealStatus";
import LoaderContent from "@/apps/public/components/LoaderContent.vue";
import {dateHelper} from "@/service/DateHelper";
import {api} from '@/service/APIClient';
import {BPagination} from "bootstrap-vue-3";
import SvgIcon from "@/apps/public/components/SvgIcon.vue";
import CopyButton from "@/apps/public/components/CopyButton.vue";
import {DisputeReason} from "@/models/enum/DisputeReason";
import {numberFormatter} from "@/service/NumberFormatter";
import PaymentTime from "@/apps/public/components/PaymentTime.vue";
import PayMethodIcon from "@/components/PayMethodIcon.vue";
import {PaymentOption} from "@/models/enum/PaymentOption";
import {useNotification} from '@kyvg/vue3-notification';
import LoaderButton from "@/apps/public/components/LoaderButton.vue";
import Multiselect from "vue-multiselect";
import {DatePicker} from "v-calendar";
import DevicesMultiselect from "@/components/DevicesMultiselect.vue";
import DealsSection from "@/apps/public/components/DealsSection.vue";
import moment from "moment";

export default defineComponent({
  methods: {$t},
  components: {
    DealsSection,
    DevicesMultiselect,
    DatePicker,
    LoaderButton,
    PayMethodIcon,
    PaymentTime,
    CopyButton,
    SvgIcon,
    BPagination,
    LoaderContent,
    TraderDashboard,
    Multiselect
  },
  setup() {
    const notification = useNotification()
    const activeDisputesSection = ref<InstanceType<typeof DealsSection> | null>(null)
    const lastDisputesSection = ref<InstanceType<typeof DealsSection> | null>(null)

    const store = useStore()
    const route = useRoute()
    const state = reactive({
    });


    onMounted(async () => {
      const accounts = await api.accountsAll();
      let currencies = []
      for (const account of accounts) {
        currencies.push(account.currency)
      }
      store.dispatch('setAccountCurrencies', currencies);

      activeDisputesSection.value?.update({
        ...defaultRequestDTO,
        statuses: [DealStatus.DISPUTE]
      }, 1, [])
      lastDisputesSection.value?.update({
        ...defaultRequestDTO,
        statuses: [DealStatus.COMPLETED, DealStatus.CANCELED, DealStatus.NEW, DealStatus.TRANSFER_WAITING, DealStatus.TRANSFER_CONFIRMED],
        hasDisputeRequest: 'y',
        updatedFromDate: moment().subtract(7, 'day').format('YYYY-MM-DD 00:00:00'),
      }, 1, [])
    })

    onUnmounted(() => {
    })


    return {
      ...toRefs(state),
      user: computed(() => store.getters.getUser),
      activeDisputesSection,
      lastDisputesSection,
      store,
      dateHelper,
      DisputeReason,
      api,
      DealStatus,
      numberFormatter,
      helper,
      PaymentOption,
      Direction,
    }
  }
})
</script>
